import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminPreorders() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/preorders").then(r => setItems(r.data)); }, []);
  return (
    <div>
      <p className="text-[10px] tracking-luxury uppercase text-gold mb-4">Concierge</p>
      <h1 className="font-editorial text-5xl mb-16 tracking-tight">Pre-orders</h1>
      <div className="border border-ivory/10">
        <div className="grid grid-cols-12 py-4 px-6 text-[10px] tracking-widest-plus uppercase text-ivory/50 border-b border-ivory/10">
          <div className="col-span-3">Client</div>
          <div className="col-span-3">Contact</div>
          <div className="col-span-4">Piece</div>
          <div className="col-span-2">When</div>
        </div>
        {items.length === 0 && <p className="p-8 text-center text-ivory/40 font-editorial-italic">No pre-orders yet.</p>}
        {items.map(p => (
          <div key={p.id} className="grid grid-cols-12 py-3 px-6 items-center border-b border-ivory/5 text-sm">
            <div className="col-span-3">{p.name}</div>
            <div className="col-span-3 text-ivory/70">{p.email}<br /><span className="text-xs text-ivory/50">{p.phone}</span></div>
            <div className="col-span-4">{p.product_name}<br /><span className="text-[10px] tracking-widest-plus uppercase text-gold">{p.size} · {p.color}</span></div>
            <div className="col-span-2 text-xs text-ivory/50">{new Date(p.created_at).toLocaleDateString()}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
